export class ChatArchiveRequest {
    conversationId: number;
    archived: boolean;
}